import { VoucherList } from 'components/voucher/voucher-list/VoucherList'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { downloadFile, getAllQueryParams, getObjectName, getQueryFilter, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/voucher/configTableVoucherList'
import { useFetch } from 'services/useFetch'
import { Alert } from 'avo-ui'
import { API_VOUCHER } from 'services/apiVoucher'
import moment from 'moment'

const INIT_FILTER = {
    type: [],
}

const INIT_STATUS = [
    {
        label: 'Publish',
        value: 'publish',
    },
    {
        label: 'Draft',
        value: 'draft',
    },
    {
        label: 'Delete',
        value: 'delete',
    },
]

export const VoucherListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const [queryFilter, setQueryFilter] = useState({})
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(INIT_STATUS[0])
    const [modalMessage, setModalMessage] = useState('')
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { fetching: getVoucherList, data: voucherList, isLoading } = useFetch(API_VOUCHER.LIST)
    const { fetching: exportVoucher, isLoading: isExporting } = useFetch(API_VOUCHER.EXPORT)
    const { fetching: bulkAction, isLoading: isBulkAction } = useFetch(API_VOUCHER.BULK_ACTION)
    const [modal, setModal] = useState({
        filter: false,
        export: false,
        confirm: false,
        delete: false,
    })

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INIT_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'type') {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        fetchVoucherList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'type'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchVoucherList = (item = { ...query, ...queryFilter }) => {
        getVoucherList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const onExport = () => {
        const combineObj = { ...query, ...queryFilter }
        const { page, limit, ...dataFilterRest } = combineObj
        const payload = { ...dataFilterRest, voucher_ids: selectedIds }
        exportVoucher(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Voucher-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('Voucher Exported', { export: false })
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onChangeStatus = (item) => {
        setSelectedStatus(item?.value)
    }

    const onApply = () => {
        if (selectedStatus?.value === INIT_STATUS[2].value) {
            setModalMessage('Are You Sure to Delete Voucher?')
            setShowModal({ delete: true })
        } else {
            setModalMessage(`Are You Sure to Change Voucher to ${selectedStatus?.label}?`)
            setShowModal({ confirm: true })
        }
    }

    const onConfirm = () => {
        const payload = {
            voucher_ids: selectedIds,
            action: selectedStatus?.value,
        }
        bulkAction(payload)
            .then(() => {
                const itemModal = selectedStatus?.value === 'delete' ? { delete: false } : { confirm: false }
                const msg = selectedStatus?.value === 'delete' ? 'Delete Data Successfully' : 'Voucher Status Updated'
                selectedStatus?.value === 'delete' && setIsResetSelectedItem(!isResetSelectedItem)
                setShowAlert(msg, itemModal)
                fetchVoucherList()
            })
            .catch((error) => {
                return Alert({
                    icon: 'error',
                    title: error?.message,
                    message: 'Periksa kembali data voucher yang masih belum dilengkapi',
                })
            })
    }

    const props = {
        dataList: voucherList?.data,
        modal,
        setShowModal,
        onSelectSort,
        query,
        onChangeQuery,
        queryFilter,
        onFilter,
        selectedIds,
        statusOptions: INIT_STATUS,
        selectedStatus,
        onChangeStatus,
        onApply,
        modalMessage,
        onConfirm,
        onExport,
        onSelectItemHandler,
        isLoading,
        isExporting,
        isBulkAction,
        isResetSelectedItem,
    }

    return <VoucherList {...props} />
}
